"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _errorMessageModule = _interopRequireDefault(require("./error-message.module.scss"));

var _fieldsize = _interopRequireWildcard(require("./fieldsize"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ErrorMessage = function ErrorMessage(_ref) {
  var _cx;

  var size = _ref.size,
      message = _ref.message,
      className = _ref.className,
      ariaLive = _ref.ariaLive;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_errorMessageModule.default.ErrorMessage, (_cx = {}, (0, _defineProperty2.default)(_cx, _errorMessageModule.default.ErrorMessageDefault, size === _fieldsize.default.DEFAULT), (0, _defineProperty2.default)(_cx, _errorMessageModule.default.ErrorMessageSmall, size === _fieldsize.default.SMALL), _cx), className),
    "aria-live": ariaLive
  }, message);
};

ErrorMessage.defaultProps = _objectSpread(_objectSpread({}, _fieldsize.fieldSizeDefaultProps), {}, {
  ariaLive: 'polite'
});
ErrorMessage.propTypes = _objectSpread(_objectSpread({}, _fieldsize.fieldSizePropTypes), {}, {
  message: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  ariaLive: _propTypes.default.oneOf(['off', 'polite', 'assertive'])
});
var _default = ErrorMessage;
exports.default = _default;